import * as React from "react";

export const ApplicantRow: React.FC<{
  label: string;
  testid: string;
  value?: string;
}> = ({ testid, value, label }) => {
  if (!value) {
    return null;
  }
  return (
    <tr>
      <th>{label}</th>
      <td>
        <p data-applicant-prop={testid}>{value}</p>
      </td>
    </tr>
  );
};
